import "./styles.css";
import LogoPalmares from "../../Imagens/logoWhite.png";
import React, { useState, useEffect } from "react";
import { AiOutlineUser, AiOutlineLeftSquare, AiOutlineAlert, AiOutlineProfile } from "react-icons/ai";
import { TbMapSearch, TbRouteAltLeft } from "react-icons/tb";
import { IoCloseCircle } from "react-icons/io5";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 960);
  const [nomeLogado, setnomeUsuarioLogado] = useState();
  const [IDLogado, setIDUsuarioLogado] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(function () {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    } else {
      let dados = JSON.parse(localStorage.getItem("usuarioLogado"));
      setnomeUsuarioLogado(dados.pessoa.nome);
      let idFormatado = String(dados.IDusuario).padStart(6, "0");
      setIDUsuarioLogado(idFormatado);
    }
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth > 960);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenuOnMobile = () => {
    if (window.innerWidth <= 960) {
      setIsOpen(false);
    }
  };

  const menuItems = [
    { to: "/Mapa", label: "Mapa", icon: <TbMapSearch /> },
    { to: "/Menu", label: "Entregas", icon: <AiOutlineProfile /> },
    { to: "/Roteamento", label: "Roteamento", icon: <TbRouteAltLeft /> },
    { to: "/Ocorrencias", label: "Ocorrencias", icon: <AiOutlineAlert /> },
  ];

  function handleLogout() {
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("palmaresAuthToken");
    navigate("/");
  }

  return (
    <div className="menu-container">
      <button
        type="button"
        className="menu-toggle"
        onClick={toggleMenu}
        aria-label="Abrir menu"
      >
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
      </button>

      <nav className={`sidebar ${isOpen ? "open" : ""}`}>
        <div id="iconeMenu">
          <div className="sidebar-brand">
            <img id="imgLogo" src={LogoPalmares} alt="Logo Prisma Route"></img>
            <div className="sidebar-brand-copy">
              <span>Painel logistica</span>
              <strong>
                {location.pathname === "/Roteamento"
                  ? "Roteirizacao"
                  : "Monitoramento"}
              </strong>
            </div>
          </div>

          <div id="dadosUsuario">
            <div className="sidebar-user-card">
              <p className="titulodados">
                <AiOutlineUser /> Usuario
              </p>
              <p className="dados">{nomeLogado || "-"}</p>
              <p className="titulodados">
                <AiOutlineLeftSquare /> ID usuario
              </p>
              <p className="dados">{IDLogado || "-"}</p>
            </div>
          </div>
        </div>

        <ul id="listamenu">
          {menuItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) => `menu-link${isActive ? " active" : ""}`}
                onClick={closeMenuOnMobile}
              >
                <span className="menu-link-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
          <li>
            <button
              type="button"
              className="menu-link logout-button"
              onClick={handleLogout}
            >
              <span className="menu-link-icon">
                <IoCloseCircle />
              </span>
              <span>Sair</span>
            </button>
          </li>
        </ul>
      </nav>

      {isOpen && window.innerWidth <= 960 ? (
        <button
          type="button"
          className="menu-backdrop"
          onClick={closeMenuOnMobile}
          aria-label="Fechar menu"
        ></button>
      ) : null}
    </div>
  );
};

export default MenuLateral;
